
import { Button } from "@/components/ui/button";
import { Zap } from "lucide-react";

interface ModalActionsProps {
  onCancel: () => void;
  onSave: () => void;
}

export const ModalActions = ({ onCancel, onSave }: ModalActionsProps) => {
  return (
    <div className="flex gap-3 pt-4">
      <Button
        onClick={onCancel}
        variant="outline"
        className="flex-1 border-[#090402]/30 text-white hover:text-white hover:bg-[#090402]/50"
      >
        Cancelar
      </Button>
      <Button
        onClick={onSave}
        className="flex-1 bg-primary hover:bg-primary/50 text-white flex items-center gap-2"
      >
        <Zap className="h-4 w-4" />
        Guardar
      </Button>
    </div>
  );
};
